import { motion } from "framer-motion";

const StatsGrid = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    {stats.map((stat, i) => (
      <motion.div
        key={i}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay: i * 0.1 }}
        className="text-center p-6 rounded-xl glass-card glass-card-hover transition-all duration-500"
      >
        <div className="font-display text-2xl md:text-3xl font-bold text-primary glow-text mb-1">
          {stat.value}
        </div>
        <div className="text-xs text-muted-foreground">{stat.label}</div>
      </motion.div>
    ))}
  </div>
);

export default StatsGrid;
